'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var discountsComponent = exports.discountsComponent = {
    template: require('./discounts.html'),
    bindings: {
        parentState: '<'
    },
    controllerAs: 'vm',
    controller: ["$scope", "productOverviewService", "Enums", "common", "gettextCatalog", "Analytics", "$stateParams", "$state", function controller($scope, productOverviewService, Enums, common, gettextCatalog, Analytics, $stateParams, $state) {
        'ngInject';

        var vm = this;
        vm.productOverviewModel = null;
        vm.$onInit = init;
        vm.onFilterChange = onFilterChange;
        vm.setIsBlackFriday = setIsBlackFriday;
        vm.isBlackFriday = false;
        vm.setBlackFriday = setBlackFriday;

        function setIsBlackFriday(value) {
            return vm.isBlackFriday = value;
        }

        function setBlackFriday() {
            if ($stateParams.filter.indexOf('10_0') !== -1) {
                $state.current.ncyBreadcrumb.label = gettextCatalog.getString('Black Friday');
                $state.current.ncyBreadcrumbLabel = gettextCatalog.getString('Black Friday');
                $state.current.ncyBreadcrumbLink = '/' + common.localization.getCurrentLanguage() + '/discounts?filter=10_0';
                setIsBlackFriday(true);
            } else {
                $state.current.ncyBreadcrumb.label = gettextCatalog.getString('Discounts');
                $state.current.ncyBreadcrumbLabel = gettextCatalog.getString('Discounts');
                $state.current.ncyBreadcrumbLink = '/' + common.localization.getCurrentLanguage() + '/discounts';
                setIsBlackFriday(false);
            }
        }
        function init() {
            common.navigationMenu.setDiscountsActive();
            common.setTitle(gettextCatalog.getString('Discounts'));
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/discounts', gettextCatalog.getString('Discounts'));
            if ($stateParams.noReloadFilter) {
                vm.productOverviewModel = productOverviewService.getProductOverviewModel();
            } else {
                vm.productOverviewModel = productOverviewService.init(Enums.searchContext.discount.id);
            }
            setBlackFriday();

            productOverviewService.getProductsByDiscounts($stateParams.noReloadFilter ? false : true, vm.productOverviewModel).then(function (model) {
                vm.productOverviewModel = model;
                productOverviewService.setProductOverviewModel(vm.productOverviewModel);
                listenForLocationChangeSuccess();
            });
        }

        function listenForLocationChangeSuccess() {
            $scope.$on('$locationChangeSuccess', function () {
                productOverviewService.getProductsByDiscounts(false, vm.productOverviewModel).then(function (model) {
                    vm.productOverviewModel = model;
                    setBlackFriday();
                });
            });
        }

        function onFilterChange() {
            $state.current.ncyBreadcrumb.label = gettextCatalog.getString('Discounts');
            $state.current.ncyBreadcrumbLabel = gettextCatalog.getString('Discounts');
            $state.current.ncyBreadcrumbLink = '/' + common.localization.getCurrentLanguage() + '/discounts';
            productOverviewService.setProductOverviewModel(vm.productOverviewModel);
        }
    }]
};


//////////////////
// WEBPACK FOOTER
// ./features/discount/discounts.js
// module id = 926
// module chunks = 0